import { captureException } from '@atlassian/error-handling/sentry';

import type {
	ProvisionStartNormalizeSeatRequest,
	ProvisionStartResponse,
} from '../provisioning-api/types';

const XFLOW_SERVICE_URL = '/gateway/api/xflow/provision/cloud';

export type NormalizeSeatStartFailureReason = 'http_error' | 'network_error' | 'invalid_response';

export class NormalizeSeatStartError extends Error {
	constructor(
		message: string,
		readonly failureReason: NormalizeSeatStartFailureReason,
		readonly httpStatus?: number,
		readonly cause?: unknown,
	) {
		super(message);
		this.name = 'NormalizeSeatStartError';
	}
}

export const normalizeSeat = async ({
	cloudId,
	signal,
}: ProvisionStartNormalizeSeatRequest): Promise<ProvisionStartResponse> => {
	try {
		let response: Response;
		try {
			response = await fetch(
				`${XFLOW_SERVICE_URL}/${encodeURIComponent(cloudId)}/product/teamwork-collection/job/nth-user-access/start`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({}),
					signal,
				},
			);
		} catch (error) {
			throw new NormalizeSeatStartError(
				'Failed to reach XFlow start endpoint',
				'network_error',
				undefined,
				error,
			);
		}

		if (!response.ok) {
			throw new NormalizeSeatStartError(
				`HTTP error! status: ${response.status}`,
				'http_error',
				response.status,
			);
		}

		try {
			return await response.json();
		} catch (error) {
			throw new NormalizeSeatStartError(
				'Invalid XFlow start response',
				'invalid_response',
				undefined,
				error,
			);
		}
	} catch (error) {
		captureException('Failed to start normalize seat job', error as Error, {
			cloudId,
			packageName: '@atlassian/twc-xflow-modal',
			teamName: 'starburst',
		});
		throw error;
	}
};
